<template>
  <div>
    <b-modal
      title="Confirm Complete"
      v-model="confirmComplete"
      @ok="submitCompleteUpdate(selectedUpdate)"
    >
      <div v-if="selectedUpdate">
        <p>Are you sure you would like to mark this update as completed?</p>

        <b-row>
          <b-col sm="3">
            <label for="confirm-opportunity">Opportunity</label>
          </b-col>
          <b-col sm="9">
            <span id="confirm-opportunity">{{
              selectedUpdate.opportunity
                ? selectedUpdate.opportunity.opportunityCategory.name
                : ""
            }}</span>
          </b-col>
        </b-row>

        <b-row>
          <b-col sm="3">
            <label for="confirm-site">Site</label>
          </b-col>
          <b-col sm="9">
            <span id="confirm-site">{{
              selectedUpdate.site ? selectedUpdate.site.name : ""
            }}</span>
          </b-col>
        </b-row>

        <p>{{ selectedUpdate.description }}</p>
      </div>
    </b-modal>

    <b-table :fields="fields" :items="informationUpdates">
      <template slot="opportunity" slot-scope="data">
        <router-link
          :to="{
            name: 'opportunity',
            params: { opportunityId: data.item.opportunityId },
          }"
          v-if="data.item.opportunity"
        >
          {{ data.item.opportunity.opportunityCategory.name }}
        </router-link>
      </template>
      <template slot="site" slot-scope="data">
        <router-link
          :to="{ name: 'site', params: { siteId: data.item.siteId } }"
          v-if="data.item.site"
        >
          {{ data.item.site.name }}
        </router-link>
      </template>
      <template slot="createdBy" slot-scope="data">
        <router-link
          :to="{ name: 'studentDetails', params: { id: data.item.createdBy } }"
          v-if="isStudentPlacementsManager"
        >
          {{ data.item.createdBy }}
        </router-link>
        <span>{{ data.item.createdBy }}</span>
      </template>
      <template slot="complete" slot-scope="data">
        <b-button @click="openCompleteConfirmation(data.item)"
          >Complete</b-button
        >
      </template>
    </b-table>

    <b-pagination
      :total-rows="totalRows"
      v-model="currentPage"
      :per-page="perPage"
      align="right"
    />
  </div>
</template>

<script>
import { mapActions, mapState } from "vuex";
import toastr from "toastr";
import ToastrSettings from "../../settings/toastr-settings";
import roleChecks from "../../misc/role-checks";

export default {
  mixins: [roleChecks],
  data() {
    return {
      currentPage: 1,
      perPage: 20,
      totalRows: 0,
      confirmComplete: false,
      selectedUpdate: null,
    };
  },

  computed: {
    ...mapState({ user: (state) => state.auth.user }),

    fields: function () {
      var tableFields = [
        { key: "opportunity", sortable: true },
        { key: "site", sortable: true },
        { key: "createdBy", label: "Submitter", sortable: true },
        { key: "description", sortable: true },
      ];

      // add field for 'Complete' button if completed prop is false
      if (!this.completed) {
        tableFields.push({ key: "complete", label: "" });
      }

      return tableFields;
    },
  },

  props: {
    informationUpdates: {
      type: Array,
      required: true,
    },

    filter: {
      type: String,
      default: "",
    },

    completed: {
      type: Boolean,
      default: true,
    },
  },

  methods: {
    ...mapActions("informationUpdates", ["completeUpdate"]),

    openCompleteConfirmation: function (informationUpdate) {
      this.selectedUpdate = informationUpdate;
      this.confirmComplete = true;
    },

    submitCompleteUpdate: function (informationUpdate) {
      this.completeUpdate(informationUpdate)
        .then(function () {
          // Toastr Message
          toastr.options = ToastrSettings;
          toastr.success("Information update marked as complete", "Success");
        })
        .catch(function (error) {
          console.log(error);
        });
    },
  },
};
</script>

<style scoped>
label {
  font-weight: bold;
}
</style>
